import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Image from 'react-bootstrap/Image';
import Message from 'components/Message';
import LoadingReviewOrder from './LoadingReviewOrder';
import ReviewForm from './ReviewForm';
import inputs from './form.json';
import { isMobileOnly } from 'react-device-detect';
import { formatDate } from 'helpers'

const ReviewOrder = ({ photos, name, details, id, orderNumber, date, ...rest }) => {
    const { main } = photos;
    const { price } = details;
    const { insideLoading, productId } = useSelector((state) => state.review);

    return insideLoading && id === productId ? (
        <LoadingReviewOrder />
    ) : (
            <div className="order order--p2" id={id}>
                {id === productId && <Message position="inside" productId={id} />}
                <div className="product__item">
                    <div className="product__thumbnail">
                        <Image src={main.thumbnail} />
                    </div>
                    <div className="product__detail">
                        <div className="product__detail--header">
                            <div className="product__price">
                                <span className="product__price--current">{`${price.current} ${price.currency}`}</span>
                                {price.old && (
                                    <span className="product__price--old">{`${price.old} ${price.currency}`}</span>
                                )}
                            </div>
                            <div
                                className="product__name"
                                dangerouslySetInnerHTML={{ __html: isMobileOnly && name.length >= 50 ? name.slice(0, 50) + '...' : name }}
                            />
                        </div>
                        <ul className="product__attributes">
                            <li className="product__attributes--item">
                                Zamówienie z <strong> {formatDate(date)}</strong>
                                <Link to={`/orders/${orderNumber}`} className="order__link">
                                    <span>Sprawdź to</span> &raquo;
                            </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="review__form">
                    <ReviewForm inputs={inputs} formId={id} />
                </div>
            </div>
        );
};

export default ReviewOrder;
